import LocalizedStrings from "react-localization";
import jsonLanguageData from "@defaultlanguagedata";

const LocaleStrings = new LocalizedStrings({
  en: {
    ...jsonLanguageData,
    static: {
      kReviewerLogin: "Reviewer Login",
      kSignInToStart: "Sign in to start your session",
      kWrongCred: "Wrong credential supplied",
      kReviewerNotFound: "Reviewer details not found.",
      kAbstractResponses: "Abstract Responses",
      kNoAbstractResponses: "No Abstract Responses",
      kReviewed: "Reviewed",
      kUnReviewed: "Un-reviewed",
      kApproved: "Approved",
      kRejected: "Rejected",
      kResubmission: "Re-submission",
      kAbstractName: "Abstract Name",
      kSubmittedBy: "Submitted By",
      kCategory: "Category",
      kAction: "Action",
      kReview: "Review",
      kRefresh: "Refresh",
      kReset: "Reset",
      kVideAbstract: "View Abstract",
      kReject: "Reject",
      kMarkAsInComplete: "Mark as incomplete",
      kClose: "Close",
      kRateSubmission: "Rate Submission",
      kSubmissionStatus: "Submission Status",
      kUnreviewed: "Unreviewed",
      kAbstractDetails: "Abstract Details",
      kSubmissionTime: "Submission Date",
      kRankSubmission: "Rank Submission",
      kComment: "Comment",
      kReviewNotStarted: "Review hasn't started yet.",
      kReviewTimeOver: "Review window is closed.",
      kReviewNow: "Review has begun!",
      kEmailInitiated: "Email initiated!",
      kEmailNotInitiated: "Sorry. Couldn't initiate email.",
      kCriteriaRankMissed: "Some category's rank is not selected.",
      kAverageRating: "Average Rating",
    },
  },
});

export default LocaleStrings;
